import {eGENA_ProblemKategorie} from './ProblemKategorieABCDE'
import { eGENA_Item } from './Item';
import { eGENA_Checkliste } from './Checkliste';
import { eGENA_ItemGroup } from './ItemGroup';


/**	Das kann entweder ein Item oder eine Item-Gruppen(=Accorion)-Titel sein.
 */
export class eGENA_ItemListElement extends eGENA_ProblemKategorie {
	public label : string;
	public zusatzinformationen : string | undefined;
	public gehörtZuItemGruppe : string | undefined;
	public linkId : number | undefined = undefined;
	public linkText : string | undefined = undefined;
	public checkbox : boolean = false;
	public checked : boolean = false; // Wird von ionic als Checkbox-Model verwendet
	public zusatzinformationenWerdenAngezeigt = false; // Es werden gerade die Zusatzinformatoinen DIESES Items angezeigt
	public istAccordionTitel : boolean = false;

	constructor(auchEtwasMitProblemen : eGENA_ProblemKategorie, label : string) {
		super(auchEtwasMitProblemen);
		this.label = label;
	}

	public static fromItem(item : eGENA_Item, checklisten : Map<number, eGENA_Checkliste>, testVersion? : boolean) : eGENA_ItemListElement {
		// Enthält das Item-label einen Link?
		let linkId : number | undefined = undefined;
		let linkText : string | undefined = undefined;
		let checkbox : boolean = false;

		if (typeof testVersion === 'undefined') {
        	testVersion = false;
		}
		
		// Falls ja, dann ist es kein Check-Item sondern ein Link-Item
		if (item.linkID != undefined) {
			let num : number = parseInt(""+item.linkID);
			item.linkID = num;
			let zielCheckliste : eGENA_Checkliste | undefined = checklisten.get(item.linkID);
			if (zielCheckliste == undefined) {
				if (!testVersion)
					throw new Error("Das Item '" + item.label + "' verweist auf eine Checkliste mit der ID '" + item.linkID + "' und dem LinkText '" + item.linkText + "', eine Checkliste mit dieser ID ist aber nicht vorhanden.");
				else {
					linkId = undefined;
					linkText = undefined;
					item.label += " ??? " + item.linkID + " ==> " + item.linkText;
				}
			}
			else {
				linkId = item.linkID;
				if (item.linkText && item.linkText.trim().length != 0)
					linkText = item.linkText;
				else {
					// Kein LInk-Text vorgegeben, wir nehmen den Titel der Ziel-Liste
					linkText = zielCheckliste.titel;
				}
			}
		}
		else {
			checkbox = true;
		}

		let instance : eGENA_ItemListElement = new eGENA_ItemListElement(item, item.label);
		instance.zusatzinformationen = item.zusatzinformationen;

		instance.linkId = linkId;
		instance.linkText = linkText;
		instance.checkbox = checkbox;
		instance.gehörtZuItemGruppe = item.itemGruppe?.name;

		return instance;
	}

	public static fromItemGruppe(itemGruppe : eGENA_ItemGroup) : eGENA_ItemListElement {
		let instance : eGENA_ItemListElement = new eGENA_ItemListElement(itemGruppe, itemGruppe.name);
		instance.istAccordionTitel = true;
		return instance;
	}


	public static fromJSONarray(objects : any[]) : eGENA_ItemListElement[] {
		let result : eGENA_ItemListElement[] = [];

		for (const object of objects) { 

			if (!('label' in object)) {
				throw new Error("Der JSON-String ist nicht im erwarteten Format: Das Attribut 'label' ist nicht definiert. JSON-String: " + JSON.stringify(object));
			}

			let item : eGENA_ItemListElement = new eGENA_ItemListElement(object, object.label);

			if ('zusatzinformationen' in object)
				item.zusatzinformationen = object.zusatzinformationen;
			if ('gehörtZuItemGruppe' in object)
				item.gehörtZuItemGruppe = object.gehörtZuItemGruppe;
			if ('linkId' in object)
				item.linkId = object.linkId;
			if ('linkText' in object)
				item.linkText = object.linkText;
			if ('checkbox' in object)
				item.checkbox = object.checkbox;
			if ('checked' in object)
				item.checked = object.checked;
			if ('zusatzinformationenWerdenAngezeigt' in object)
				item.zusatzinformationenWerdenAngezeigt = object.zusatzinformationenWerdenAngezeigt;
			if ('istAccordionTitel' in object)
				item.istAccordionTitel = object.istAccordionTitel;

			result.push(item);
		}

		return result;
	}


}


// WEBPACK FOOTER //
// ./src/visionet/ItemListElement.ts